import {Component, Input, OnInit} from "@angular/core";
import {DialogComponent} from "../../../../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../../../../ng2-bootstrap-modal/dialog.service";
import {DbResponse} from "../../../../../shared/interceptors/db-response";
import {HostingService} from "../../hosting.service";
import {DbServerErrors} from "../../../../../shared/interceptors/db-server-errors";
import {HostingDomainData} from "../../domains/hostingDomainData";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../../store';
import { filter, first } from "rxjs";

export interface IRemoveCertificate {
  websiteId: number;
  selectedDialog: string;
  websiteIp: string;
  allDomains: HostingDomainData[];
}

@Component({
    selector: 'db-remove-certificate',
    templateUrl: './remove-certificate.component.html',
    styleUrls: ['./remove-certificate.component.scss'],
    standalone: false
})
export class RemoveCertificateComponent extends DialogComponent<IRemoveCertificate, boolean> implements OnInit, IRemoveCertificate {
  @Input() websiteId: number;
  @Input() selectedDialog: string;
  @Input() websiteIp: string;
  @Input() allDomains: HostingDomainData[];
  public isMobile: boolean;
  public continue: boolean = false;
  public loading: boolean;
  public domains: FormControl;
  public removeCustomCertificate: FormGroup;
  public removeFreeCertificateForm: FormGroup;
  public domainNameIds: any;
  public serverErrors: DbServerErrors;

  constructor(
    private _dialogService: DialogService,
    private _store: Store<fromStore.DbStoreState>,
    private _hostingService: HostingService
  ) {
    super(
      _dialogService
    );

    this.removeCustomCertificate = new FormGroup({
      'keyFileContents': new FormControl('', [Validators.required]),
      'certFileContents': new FormControl('', [Validators.required]),
      'caFileContents': new FormControl(''),
      'redirectHttp': new FormControl(1)
    });

    this.removeFreeCertificateForm = new FormGroup({
      'domainNameIds': new FormControl('', [Validators.required]),
      'redirectHttp': new FormControl(1)
    });
  }

  ngOnInit() {
    this.domainNameIds = [];
    this.domains = new FormControl("");
    if (window.innerWidth < 991) {
      this.isMobile = true;
    }
  }

  public addClass(index) {
    const elementValue = (<HTMLInputElement>document.getElementById("removeHttps_" + index)).value;
    const elementParent = document.getElementById("removeHttps_" + index).parentElement.parentElement;
    if (elementParent.classList.contains('checked')) {
      elementParent.classList.remove('checked');
      let number = this.domainNameIds.indexOf(elementValue);
      if (number > -1) {
        this.domainNameIds.splice(number, 1);
      }
    } else {
      elementParent.classList.add('checked');
      this.domainNameIds.push(elementValue);
    }
  }

  public removeFreeCertificate(): void {
    this.loading = true;
    this.serverErrors = null;
    this._hostingService.removeCertificate(this.websiteId, this.domainNameIds)
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        this.loading = false;
        if (response.success) {
          this.result = true;
          this.close();
        }
        else {
          this.serverErrors = response.serverErrors;
        }
      });
  }

  public nextPopUp(): void {
    this.continue = true;
  }

  public back(): void {
    this.continue = false;
  }

  public cancel(): void {
    this.result = false;
    this.close();
  }

  public confirm(): void {
    this.result = true;
    this.close();
  }

}
